<template>
  <el-dialog
    title=""
    :visible.sync="isOpen"
    width="8.48rem"
    append-to-body
    :close-on-click-modal="false"
    destroy-on-close
    :footer="null"
    @close="close"
  >
    <div style="width:90%;margin:0 auto;">
      <div class="img-box">
        <img src="@/assets/image/loan/success.png"/>
      </div>
      <div class="img-title">{{pageData.isAll ? "Borrow Position Closed!" : "Partial Repayment Confirmed!"}}</div>
      <div class="spaceCenter">
        <div class="detail-item spaceLeft" style="margin:0.2rem 0.4rem;">
          <span class="detail-item-label">Collateral Released:</span>
          <span><big-number :number="pageData.unitRefund"/></span><span class="unit">UNIT</span>
        </div>
        <div class="detail-item spaceLeft" v-if="!pageData.isAll" style="margin:0.2rem 0.4rem;">
          <span class="detail-item-label">Pending Repayment:</span>
          <span><big-number :number="pageData.Unrepaid"/></span><span class="unit">TCash</span>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      pageData: {}
    };
  },
  computed: {},
  methods: {
    open({ data } = {}) {
      this.isOpen = true;
      this.pageData = data || {};
    },
    close() {
      this.isOpen = false;
      this.pageData = {};
      this.$emit("success");
    }
  },
  created() {}
};
</script>
<style scoped lang="scss">
.unit {
  font-size: 0.16rem;
  font-weight: 400;
  color: #929dad;
  margin-left: 0.04rem;
  margin-bottom: -0.05rem;
}
.img-box{
  text-align: center;
  &img{
    width:1.82rem;
  }
}
.img-title{
  font-size: 0.32rem;
  font-weight: bold;
  color: #1F1F1F;
  text-align: center;
  margin:0.32rem 0 0.26rem 0;
}
.detail-item{
  margin-bottom: 0.24rem;
}
.balance-box{
  position: relative;
  flex:1 0 0;
  &>span{
    position: absolute;
    right:0.02rem;
    top:-0.3rem;
  }
  ::v-deep  .el-input__inner{
    height: 0.48rem;
    background: #F7F8FA;
    border-color:#F7F8FA;
  }
  ::v-deep  .el-input-group__append{
    background: #F7F8FA;
    border-color:#F7F8FA;
    font-size: 0.18rem;
    color:#AAAAAA;
  }
}

.big-number {
  font-weight: 500;
}
</style>
